var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 29,
    viewBox: "0 0 38 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32284 28.4023H32.0312C35.5013 28.4023 37.3384 26.5653 37.3384 23.1266V6.2474C37.3384 2.79305 35.5013 0.971664 32.0312 0.971664H5.32284C1.85279 0.971664 0 2.79305 0 6.2474V23.1266C0 26.581 1.85279 28.4023 5.32284 28.4023ZM3.50146 6.60854C3.50146 5.16399 4.23943 4.45742 5.62117 4.45742H31.7329C33.099 4.45742 33.8526 5.16399 33.8526 6.60854V7.67624H3.50146V6.60854ZM5.62117 24.9009C4.23943 24.9009 3.50146 24.21 3.50146 22.7655V11.4289H33.8526V22.7655C33.8526 24.21 33.099 24.9009 31.7329 24.9009H5.62117Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6349 22.1531H7.78802C6.86163 22.1531 6.24927 21.5407 6.24927 20.6458V17.741C6.24927 16.8617 6.86163 16.2336 7.78802 16.2336H11.6349C12.5613 16.2336 13.1737 16.8617 13.1737 17.741V20.6458C13.1737 21.5407 12.5613 22.1531 11.6349 22.1531Z",
    fill: "#FE2C55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Icon);
export default __webpack_public_path__ + "static/media/step2_icon.75adce9e310b9223eb9d9c27eb162368.svg";
export { ForwardRef as ReactComponent };